export default __webpack_public_path__ + "static/media/mates.55c0c6fd.png";